/* eslint-disable @typescript-eslint/no-explicit-any */

export interface LogAppender {
  debug?: (...args: any[]) => void;
  info?: (...args: any[]) => void;
  warn?: (...args: any[]) => void;
  error?: (...args: any[]) => void;
  errorWithScope?: (contextName: string, contextValue: {[index: string]: any}, ...args: any[]) => void;
}

export enum LogLevel {
  debug,
  info,
  warn,
  error,
  none
}

const consoleAppender: LogAppender = {
  debug: (...args) => {
    window.console.debug(...args);
  },
  info: (...args) => {
    window.console.info(...args);
  },
  warn: (...args) => {
    window.console.warn(...args);
  },
  error: (...args) => {
    window.console.error(...args);
  },
  errorWithScope: (...args) => {
    window.console.error(...args);
  }
};

const appenders: LogAppender[] = [consoleAppender];

export function registerAppender(appender: LogAppender): void {
  appenders.push(appender);
}

let _logLevel = LogLevel.debug;

export function setLogLevel(logLevel: LogLevel): void {
  _logLevel = logLevel;
}

export function debug(...args: any[]): void {
  /* istanbul ignore next else */
  if (_logLevel <= LogLevel.debug) {
    appenders
      .filter((appender) => typeof appender.debug === 'function')
      .forEach((appender) => {
        appender.debug(...args);
      });
  }
}

export function info(...args: any[]): void {
  /* istanbul ignore next else */
  if (_logLevel <= LogLevel.info) {
    appenders
      .filter((appender) => typeof appender.info === 'function')
      .forEach((appender) => {
        appender.info(...args);
      });
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function warn(...args: any[]): void {
  /* istanbul ignore next else */
  if (_logLevel <= LogLevel.warn) {
    appenders
      .filter((appender) => typeof appender.warn === 'function')
      .forEach((appender) => {
        appender.warn(...args);
      });
  }
}

export function error(...args: any[]): void {
  /* istanbul ignore next else */
  if (_logLevel <= LogLevel.error) {
    appenders
      .filter((appender) => typeof appender.error === 'function')
      .forEach((appender) => {
        appender.error(...args);
      });
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function errorWithScope(contextName: string, contextValue: {[index: string]: any}, ...args: any[]): void {
  if (_logLevel <= LogLevel.error) {
    appenders
      .filter((appender) => typeof appender.errorWithScope === 'function')
      .forEach((appender) => {
        appender.errorWithScope(contextName, contextValue, ...args);
      });
  }
}
